import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { ROLE, TOKEN, NAME } from '../../../_helpers/token';

class SidebarContent extends Component {
  static propTypes = {
    changeToDark: PropTypes.func.isRequired,
    changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };
  componentDidMount() {
    // axios.get(baseURL).then(res => { })

    if (TOKEN == null) {
      window.location.href = "/log_in";

    }
  }
  logout = () => {
    localStorage.removeItem('token');
  }
  render() {
    const { changeToLight, changeToDark } = this.props;



    return (
      <div className="sidebar__content">
        <ul className="sidebar__block">
          <SidebarCategory title="Layout" icon="layers">
            <button className="sidebar__link" type="button" onClick={changeToLight}>
              <p className="sidebar__link-title">Light Theme</p>
            </button>
            <button className="sidebar__link" type="button" onClick={changeToDark}>
              <p className="sidebar__link-title">Dark Theme</p>
            </button>
          </SidebarCategory>
        </ul>
        <ul className="sidebar__block">


          {ROLE !== '10' ?
            <>
              {/* <SidebarLink
                title="PawaBox Search"
                route="/user_search"
                icon="user"
                onClick={this.hideSidebar}
              /> */}

              <SidebarLink
                title="User Search"
                icon="user"
                route="/user"
                onClick={this.hideSidebar}
              />
            </>
            : null
          }

          {ROLE === '6' || ROLE === '7' ?
            <>

              {/* <SidebarLink
                title="PawaBox Stats"
                route="/players"
                icon="book"
                onClick={this.hideSidebar}
              /> */}
              <SidebarCategory title="Today Management" icon="book">

                <SidebarLink title="Gaming Income" route="/gamingincome" onClick={this.hideSidebar} />
                <SidebarLink title="Times played" route="/timesplayed" onClick={this.hideSidebar} />


                <SidebarLink title="NetCashFlow" route="/netcashflow" onClick={this.hideSidebar} />
                <SidebarLink title="House Income Report" route="/houseincome" onClick={this.hideSidebar} />
                <SidebarLink title="EWallet" route="/ewallet" onClick={this.hideSidebar} />

                <SidebarLink title="JackPot Winners" route="/jackpot" onClick={this.hideSidebar} />
                <SidebarLink title="JackPot Counts" route="/jackpotcount" onClick={this.hideSidebar} />
                <SidebarLink title="Wins vs Losses" route="/winloss" onClick={this.hideSidebar} />

                <SidebarLink title="Daily Tickets" route="/tickets_t" onClick={this.hideSidebar} />


                <SidebarCategory title="Deposits">
                  {/* <SidebarLink title="Deposit Requests" route="/DepositRequests" icon="briefcase" onClick={this.hideSidebar} /> */}
                  <SidebarLink title="Daily Deposits" route="/dailydeposit" onClick={this.hideSidebar} />


                </SidebarCategory>
                <SidebarCategory title="Withdrawals">
                  <SidebarLink title="Withdrawals Summary" route="/withdrawalsummary" onClick={this.hideSidebar} />
                  <SidebarLink title="Withdrawals Archives" route="/customers-withdrawals" onClick={this.hideSidebar} />
                  <SidebarLink title="Transaction (Withdrawals)" route="/transaction" onClick={this.hideSidebar} />
                </SidebarCategory>
                <SidebarCategory title="Bets">
                  <SidebarLink title="Online vs SMS counts" route="/onlinevsms" onClick={this.hideSidebar} />

                  <SidebarLink title="Bets Per Day" route="/betsperday" onClick={this.hideSidebar} />

                  <SidebarLink title="Bets Per Hour" route="/betsperhour" onClick={this.hideSidebar} />

                  {/* <SidebarLink title="Other Winners" route="/otherwinners" onClick={this.hideSidebar} /> */}
                  <SidebarLink title="Average Bets" route="/averagebets" onClick={this.hideSidebar} />
                </SidebarCategory>
              </SidebarCategory>

              {/* <SidebarCategory title="This Month Business" icon="book">
                <SidebarLink title="Gaming Income" route="/incomemonthly" onClick={this.hideSidebar} />
                <SidebarCategory title="Deposits">
                  <SidebarLink title="Deposits Summary" route="/depositsmonthly" onClick={this.hideSidebar} />
                </SidebarCategory>
                <SidebarCategory title="Withdrawals">
                  <SidebarLink title="Withdrawals Summary" route="/withdrawlsummarymonthly" onClick={this.hideSidebar} />
                </SidebarCategory>
                <SidebarLink title="JackPot Counts" route="/jackpotmonthly" onClick={this.hideSidebar} />
                <SidebarLink title="Bets" route="/betmonthly" onClick={this.hideSidebar} />
              </SidebarCategory> */}
            </> :
            null
          }


          {ROLE === '10' ?
            <>


              <SidebarLink icon="users" title="Customers" route="/presenters" onClick={this.hideSidebar} />
              <SidebarLink icon="users" title="Customer Counts" route="/countdd" onClick={this.hideSidebar} />
              <SidebarLink icon="briefcase" title="Deposits" route="/presenter_deposits" onClick={this.hideSidebar} />

              <SidebarLink icon="briefcase" title="Withdrawal" route="/presenter_withdrawals" onClick={this.hideSidebar} />

              <SidebarLink icon="briefcase" title="Incoming SMS" route="/sms_presenters" onClick={this.hideSidebar} />

              <SidebarLink icon='diamond' title="Bets Per Day" route="/betsperday_h" onClick={this.hideSidebar} />

              <SidebarCategory icon="bullhorn" title="Run Draws">
                <SidebarLink title="Winner Select" route="/presenter_winner" onClick={this.hideSidebar} />
                <SidebarLink title="Draw Winners" route="/draw_presenters" onClick={this.hideSidebar} />
              </SidebarCategory>



            </>
            :
            <>
              <SidebarCategory title="Customers" icon="book">
                <SidebarLink title="Bets Per Day" route="/betsperday" onClick={this.hideSidebar} />
                <SidebarLink title="PromoCode" route="/promosearch" onClick={this.hideSidebar} />

                <SidebarLink title="Active PromoCodes" route="/promocodeowners" onClick={this.hideSidebar} />

                <SidebarLink title="Incoming calls" route="/customerfeedback" onClick={this.hideSidebar} />

                <SidebarLink title="Out going calls" route="/outgoingcustomerfeedbacks" onClick={this.hideSidebar} />

                <SidebarLink title="Calls Analysis" route="/customersaftercall" onClick={this.hideSidebar} />
                <SidebarLink title="Call Assist Logs" route="/callassist" onClick={this.hideSidebar} />



                <SidebarLink title="Newly Recruited" route="/newlycustomer" onClick={this.hideSidebar} />

                <SidebarLink title="Recruits vs Deposits" route="/newlyrecruiteddeposits" onClick={this.hideSidebar} />

                <SidebarLink title="Recruits vs Deposits Customers" route="/newlyrecruitscustomer" onClick={this.hideSidebar} />

                {/* <SidebarLink title="Customer Subscription Numbers" route="/subscriptionnumbers" onClick={this.hideSidebar} /> */}





                <SidebarLink
                  title="Incoming Messages"
                  route="/customerincomingMessages"
                  onClick={this.hideSidebar}
                />


                {/* <SidebarLink title="Billing Attempts" route="/dsilybilled" onClick={this.hideSidebar} /> */}


                <SidebarLink title="Active Customers" route="/activecustomers" onClick={this.hideSidebar} />
                {/* <SidebarLink title="Total Unsuccessful Depositors" route="/depositattemptscustomer" onClick={this.hideSidebar} /> */}

                <SidebarLink title="InActive Customers (Less than a month)" route="/inactivecustomers" onClick={this.hideSidebar} />
                <SidebarLink title="InActive Customers (Over a month)" route="/inactivecustomersmonth" onClick={this.hideSidebar} />
                <SidebarLink title="Customer Recruitment" route="/customersubscription" onClick={this.hideSidebar} />

                <SidebarCategory title="Times Played">

                  <SidebarLink title="For Today" route="/threedayscustomers" onClick={this.hideSidebar} />

                  <SidebarLink title="Less than thrice for Yesterday" route="/yesterdaycustomers" onClick={this.hideSidebar} />

                  <SidebarLink title="Less than 4 times in a month" route="/playforthtimescustomers" onClick={this.hideSidebar} />

                  <SidebarLink title="Less than four times over a month" route="/playoveramonth" onClick={this.hideSidebar} />
                </SidebarCategory>
                {/* 

                <SidebarLink title="Other Winners" route="/otherwinners" onClick={this.hideSidebar} />
                <SidebarLink title="Average Bets" route="/averagebets" onClick={this.hideSidebar} /> */}
              </SidebarCategory>

              <SidebarCategory icon="bullhorn" title="Run Draws">
                <SidebarLink title="Winner Select" route="/winner_select" onClick={this.hideSidebar} />
                <SidebarLink title="Draw Winners" route="/drawwinner" onClick={this.hideSidebar} />
              </SidebarCategory>


              <SidebarLink
                title="Social Media Posts"
                icon="file-add"
                route="/socialmediaposts"
                onClick={this.hideSidebar}
              />


              <SidebarLink
                title="Full Winners' Info"
                icon="user"
                route="/customerfullinfo"
                onClick={this.hideSidebar}
              />

              <SidebarCategory title="Reconciliation" icon="briefcase">
                <SidebarLink title="Deposits Mpesa" route="/reconciledeposits" onClick={this.hideSidebar} />

                <SidebarLink title="Deposits Tigo" route="/default_tigo" onClick={this.hideSidebar} />


              </SidebarCategory>
              <SidebarCategory title="Audit Trails" icon="briefcase">
                <SidebarLink title="Login Audits" route="/audit" onClick={this.hideSidebar} />
                <SidebarLink title="Customer Perfomance" route="/audit_performance" onClick={this.hideSidebar} />
              </SidebarCategory>

            </>
          }

          {/* 
          //   <Route path="/" component={CustomerFullInfo} />

    // <Route path="/" component={SocialMedia} /> */}





          {ROLE === '4' ?
            <>

              <SidebarCategory title="Unsuccessful Depositors" icon="briefcase">
                <SidebarLink title="MTN Deposits" route="/calledstatus" onClick={this.hideSidebar} />
                <SidebarLink title="Deposit Requests" route="/DepositRequests" onClick={this.hideSidebar} />
              </SidebarCategory>

              <SidebarCategory title="Unsuccessful Withdrawers" icon="briefcase">
                <SidebarLink title="Withdrawal" route="/transaction" onClick={this.hideSidebar} />
              </SidebarCategory>
            </> : null}




          {ROLE === '2' ?
            <>
              <SidebarCategory title="Unsuccessful Depositors" icon="briefcase">
                <SidebarLink title="MTN Deposits" route="/calledstatus" onClick={this.hideSidebar} />
                <SidebarLink title="Deposit Requests" route="/DepositRequests" onClick={this.hideSidebar} />
              </SidebarCategory>

              <SidebarCategory title="Unsuccessful Withdrawers" icon="briefcase">
                <SidebarLink title="Withdrawal" route="/transaction" onClick={this.hideSidebar} />
              </SidebarCategory>

              <SidebarCategory title="Blasts" icon="phone">

                {/* <SidebarLink title="Secure D" route="/secureblast" onClick={this.hideSidebar} /> */}

                <SidebarLink title="New Target" route="/secured_d_inactive" onClick={this.hideSidebar} />

                <SidebarLink title="SDP Customers" route="/never_deposited" onClick={this.hideSidebar} />
                {/* <SidebarLink title="Send Blast Based on time created" route="/sendmonthly" onClick={this.hideSidebar} />
                <SidebarLink title="Active Depositors" route="/active_blasts" onClick={this.hideSidebar} />
                <SidebarLink title="Blast Never Deposited" route="/never_deposited" onClick={this.hideSidebar} />


                <SidebarLink title="Played counts" route="/blastcountplayed" onClick={this.hideSidebar} /> */}



                <SidebarLink title="Queue Messages" route="/bulksms" onClick={this.hideSidebar} />
              </SidebarCategory>


            </> :
            null
          }






          {ROLE === '10' ?
            <>

              <SidebarCategory title="Finance" icon="briefcase">

                <SidebarLink title="Gaming Income" route="/gamingincome" onClick={this.hideSidebar} />
                {/* <SidebarLink title="NetCashFlow" route="/netcashflow" onClick={this.hideSidebar} /> */}
                {/* <SidebarLink title="House Income Report" route="/houseincome" onClick={this.hideSidebar} /> */}
                <SidebarLink title="EWallet" route="/ewallet" onClick={this.hideSidebar} />
                {/* <SidebarLink title="Stake" route="/stake" onClick={this.hideSidebar} /> */}

                <SidebarLink title="Subscription Status" route="/subscriptionstatus" onClick={this.hideSidebar} />

                <SidebarLink title="Wins vs Losses" route="/winloss" onClick={this.hideSidebar} />



                <SidebarLink title="Billing Attempts" route="/dsilybilled" onClick={this.hideSidebar} />
                <SidebarLink title="SDP Billing" route="/subscriptionssdp" onClick={this.hideSidebar} />
                <SidebarLink title="SDP vs OTA Billing" route="/subscriptionsdpota" onClick={this.hideSidebar} />


                <SidebarCategory title="Deposits">
                  <SidebarLink title="Deposit Requests" route="/DepositRequests" icon="briefcase" onClick={this.hideSidebar} />
                  <SidebarLink title="Daily Deposits" route="/dailydeposit" onClick={this.hideSidebar} />
                  <SidebarLink title="Paystack Deposits" route="/paystack" onClick={this.hideSidebar} />
                  <SidebarLink title="MTN Deposits Analysis" route="/mtnanaylsis" onClick={this.hideSidebar} />


                  {/* <SidebarLink title="MTN Deposits" route="/mtndeposit" onClick={this.hideSidebar} />
                  <SidebarLink title="MTN Deposits Success Rates" route="/mtnsuccess" onClick={this.hideSidebar} /> */}

                  <SidebarLink title="Unique Depositors" route="/uniquedepositor" onClick={this.hideSidebar} />

                </SidebarCategory>


                <SidebarCategory title="Withdrawals">
                  <SidebarLink title="Withdrawals Summary" route="/withdrawalsummary" onClick={this.hideSidebar} />
                  <SidebarLink title="Withdrawals Archives" route="/customers-withdrawals" onClick={this.hideSidebar} />
                  <SidebarLink title="Transaction (Withdrawals)" route="/transaction" onClick={this.hideSidebar} />
                  <SidebarLink title="PayStack Withdrawals" route="/interswitch" onClick={this.hideSidebar} />
                  <SidebarLink title="Paycode Withdrawals" route="/paystackwith" onClick={this.hideSidebar} />
                </SidebarCategory>
              </SidebarCategory>


              <SidebarCategory title="Bets" icon="book">
                <SidebarLink title="Cohort Analysis" route="/cohortAnalysis" onClick={this.hideSidebar} />

                <SidebarLink title="Online vs SMS counts" route="/onlinevsms" onClick={this.hideSidebar} />

                <SidebarLink title="Bets Per Day" route="/betsperday" onClick={this.hideSidebar} />
                <SidebarLink title="Bets Per Hour" route="/betsperhour" onClick={this.hideSidebar} />

                <SidebarLink title="Bets Per Type" route="/betstype" onClick={this.hideSidebar} />
                <SidebarLink title="JackPot" route="/jackpot" onClick={this.hideSidebar} />
                <SidebarLink title="JackPot Per Day" route="/jackpotcount" onClick={this.hideSidebar} />

                <SidebarLink title="Other Winners" route="/otherwinners" onClick={this.hideSidebar} />

                <SidebarLink title="Live Ticket Jackpot Winners" route="/jackpotlive" onClick={this.hideSidebar} />

                <SidebarLink title="Average Bets" route="/averagebets" onClick={this.hideSidebar} />
              </SidebarCategory>

              <SidebarCategory title="Radio Campaign Report" icon="bullhorn">

                <SidebarLink title="Campaign Recruitement" route="/compaignrecruitment" onClick={this.hideSidebar} />
                <SidebarLink title="Campaign Deposits" route="/compaigndeposit" onClick={this.hideSidebar} />
                <SidebarLink title="Campaign Bets" route="/compaignbet" onClick={this.hideSidebar} />
              </SidebarCategory>


              <SidebarCategory title="Report" icon="book">

                <SidebarLink title="Billing Attempts" route="/dsilybilled" onClick={this.hideSidebar} />

                <SidebarLink title="Revenue Channel" route="/revenuechannel" onClick={this.hideSidebar} />
                <SidebarLink title="Times played" route="/timesplayed" onClick={this.hideSidebar} />
                <SidebarLink title="Summary" route="/summary" onClick={this.hideSidebar} />
                <SidebarLink title="EOD" route="/eod" onClick={this.hideSidebar} />

              </SidebarCategory>


              <SidebarCategory title="Blasts" icon="phone">
                {/* <SidebarLink title="Secure D" route="/secureblast" onClick={this.hideSidebar} /> */}

                <SidebarLink title="New Target" route="/secured_d_inactive" onClick={this.hideSidebar} />
                <SidebarLink title="SDP Customers" route="/never_deposited" onClick={this.hideSidebar} />

                {/* <SidebarLink title="Send Blast Last Active" route="/blasts" onClick={this.hideSidebar} />
                <SidebarLink title="Send Blast Based on time created" route="/sendmonthly" onClick={this.hideSidebar} />
                <SidebarLink title="Active Depositors" route="/active_blasts" onClick={this.hideSidebar} />
                <SidebarLink title="Blast Never Deposited" route="/never_deposited" onClick={this.hideSidebar} />


                <SidebarLink title="Played counts" route="/blastcountplayed" onClick={this.hideSidebar} /> */}


                <SidebarLink title="Queue Messages" route="/bulksms" onClick={this.hideSidebar} />
              </SidebarCategory>


              <SidebarCategory title="Audit Trails" icon="briefcase">
                <SidebarLink title="Login Audits" route="/audit" onClick={this.hideSidebar} />
                <SidebarLink title="Customer Perfomance" route="/audit_performance" onClick={this.hideSidebar} />
              </SidebarCategory>


              <SidebarLink title="Online Notifications" icon="bullhorn" route="/onlinenotifications" onClick={this.hideSidebar} />


            </> : null}




          {ROLE !== '10' ?
            <SidebarLink title="Blacklist" route="/blacklist" icon="users" onClick={this.hideSidebar} />
            : null}
        </ul>


        <ul className="sidebar__block">
          {ROLE === '4' ?
            <>
              <SidebarLink title="Terms and Conditions" route="/termscon" icon="book" onClick={this.hideSidebar} />
            </> : null}

          {NAME === 'Andrew Mbuya' ?
            <SidebarCategory title="Settings" icon="gear" >

              <SidebarLink title="Reset Jackpot" route="/reserve_jackpot" onClick={this.hideSidebar} />

              <SidebarLink title="Set Mini Jackpot" route="/mini_jackpot" onClick={this.hideSidebar} />


            </SidebarCategory>
            : null

          }
        </ul>


        <ul className="sidebar__block">
          <SidebarLink
            title="Logout"
            route="/log_in"
            onClick={this.logout}
            icon="exit"
          />
        </ul>

      </div >
    );
  }
}

export default SidebarContent;
